<template>
  <section>
    <div class="blocked_warning">
      <div class="icon">
        <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
      </div>
      <div class="content flex-1">
        <div class="tips flex-sb-center">
          <span> This customer has the following warning(s).</span>
          <p
            v-if="block_updated_date"
            class="text-right color-gray fs-14 fw-400"> {{block_updated_date}}</p>
        </div>
        <div>
          <template v-if="block_data.length>0">
            <p class="tips mg-t-10 ">Blocked</p>
            <div class="flex flex-wrap mg-t-5">
              <p
                v-for="(item, i) in block_data"
                :key="i"
                class="block-text">
                {{blockName(item)}} <span v-if="(i+1)<block_data.length">,</span>
              </p>
            </div>
          </template>
          <p
            v-if="customerProfile.block_reference_nm"
            class="block-text">Reference Name : {{customerProfile.block_reference_nm}}</p>
        </div>
        <span    v-if="block_remark">
          <p class="tips mg-t-10">Remark</p>
          <p
            class="block-text mg-t-5"
            v-html="changeLineText(block_remark)"> </p>
        </span>

      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'BlockWarning',
  mixins: [MixinOptions],
  props:{
    customerProfile:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {

    }
  },
  computed:{
    classList(){
      let arr = this.globalOptions.class_data.filter(item => item.id < 50) || []
      arr.unshift({
        id: 0,
        name: 'All'

      })
      return arr
    },
    blockName(){
      let arr = this.classList||[]
      return(name)=>{
        let result = ''
        arr.some(item => {
          if (item.id == name) {
            result = item.name
            return true
          }
          return false
        })
        return result
      }

    },
    block_remark(){
      let {block_remark=''} = this.customerProfile||{}
      return block_remark||''
    },
    block_data(){
      let {block_data=[]} = this.customerProfile||{}
      return block_data||[]
    },
    block_updated_date(){
      let {block_updated_date=''} = this.customerProfile||{}
      return block_updated_date||''
    }
  },
  methods: {

  },
}
</script>
<style lang='scss' scoped>
.blocked_warning{
  padding: 15px;
  display: flex;
  background: #FFE3E6;
  border: 1px solid rgba(158, 28, 35, 0.2);
  border-radius: 6px;
  .icon{
    font-size: 14px;
    color: #CB2431;
  }
  .content{
    margin-left: 16px;
    .tips{
      font-weight: 600;
      font-size: 14px;
      color: #24292E;
    }
    .block-text{
      font-weight: 400;
      font-size: 14px;
      color: #24292E;
      line-height: 20px;
    }
    .flex-wrap{
      flex-wrap: wrap;
    }
    ul{
      padding-left: 20px;
      display: flex;
      flex-wrap: wrap;
      li{
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
        line-height: 20px;
      }
    }
    .list{
      margin-top: 15px;

    }
  }
}
</style>
